export default __webpack_public_path__ + "static/media/physical-redeem.ad8a26a9.svg";